'use client';

import { SupportedInsightsAsset } from '@/app/api/constants';
import { SelectWithSearch } from '@/components';
import { twMerge } from 'tailwind-merge';

export const AssetDropdown = ({
  asset,
  onSelect,
  className,
  showLabel = true,
}: {
  asset: SupportedInsightsAsset;
  onSelect: (asset: SupportedInsightsAsset) => void;
  className?: string;
  showLabel?: boolean;
}) => {
  return (
    <div className={twMerge('w-fit flex items-center gap-x-2', className)}>
      {showLabel && <p className="text-neutral-100">Select asset:</p>}
      <SelectWithSearch
        className="mx-auto"
        searchable={false}
        options={Object.values(SupportedInsightsAsset).map((asset) => ({
          label: asset,
          value: asset,
        }))}
        onSelect={(value) => onSelect(value.value)}
        selectedOption={{ label: asset, value: asset }}
      />
    </div>
  );
};
